import classNames from 'classnames'
import Tooltip, { TooltipProps } from 'antd/lib/tooltip'
import styles from './GroupTooltip.module.scss'

export const GroupTooltip = (props: TooltipProps) => (
  <Tooltip className={classNames(styles.root, props.className)} {...props} />
)

export default GroupTooltip
